// src/services/menu.ts
import { API_BASE } from "./apiBase.ts";

// src/services/menu.ts
export async function fetchMenuTitles(accessToken: string, email?: string): Promise<string[]> {
  const res = await fetch(`${API_BASE}/api/menu-titles`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      ...(email ? { "X-User-Email": email } : {}),
    },
    credentials: "include",
    cache: "no-store",
  });
  if (!res.ok) throw new Error(`menu destinations ${res.status}`);
  return res.json();
}

export async function fetchMenu(accessToken: string, email?: string) {
  const res = await fetch(`${API_BASE}/api/menu`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      ...(email ? { "X-User-Email": email } : {}),
    },
    credentials: "include",
    cache: "no-store",
  });

  if (!res.ok) {
    throw new Error(`menu ${res.status}`);
  }
  return res.json();
}

export async function setDefaultMenuItem(accessToken: string, key: string, email?: string) {
  const res = await fetch(`${API_BASE}/api/me/default-menu-item`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
      ...(email ? { "X-User-Email": email } : {}),
    },
    credentials: "include",
    body: JSON.stringify({ key }),
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`default menu ${res.status}: ${text}`);
  }

  return res.json();
}

export async function clearDefaultMenuItem(accessToken: string, email?: string) {
  const res = await fetch(`${API_BASE}/api/me/default-menu-item`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      ...(email ? { "X-User-Email": email } : {}),
    },
    credentials: "include",
  });

  if (!res.ok && res.status !== 204) {
    const text = await res.text();
    throw new Error(`default menu delete ${res.status}: ${text}`);
  }
}

